import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import { canPay, canUse, canRefund, canChange } from '@/utils/order';
import { getOrderList as _getOrderList, cancelOrder, cancelPart } from '@/api';
import moment from 'moment';
import PageTitle from '@/components/PageTitle';
export default {
  components: {
    orderDetailDialog: function orderDetailDialog() {
      return import("./MyOrder/orderDetail");
    },
    ChangeDialog: function ChangeDialog() {
      return import("./MyOrder/changeDialog");
    },
    PageTitle: PageTitle
  },
  data: function data() {
    return {
      tableData: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      orderInfo: {},
      rotating: false
    };
  },
  mounted: function mounted() {
    this.getOrderList();
  },
  computed: {
    allowUserPartCancel: function allowUserPartCancel() {
      return this.$store.state.projectConfig.allow_user_part_cancel;
    }
  },
  methods: {
    canPay: canPay,
    canUse: canUse,
    canRefund: canRefund,
    canChange: canChange,
    getOrderList: function getOrderList() {
      var _this = this;

      _getOrderList(this.page).then(function (res) {
        if (!res.data.extraInfo.list.length) {
          _this.$router.push({
            name: 'ticket'
          });

          return;
        }

        res.data.extraInfo.list.forEach(function (order) {
          order.create_time = moment(order.create_time).format('YYYY-MM-DD HH:mm:ss');
          var tickets = order.tickets.filter(function (i) {
            return i.status !== 'CHANGED';
          });

          if (tickets.length * 2 === order.tickets.length) {
            order.is_changed = true;
          }

          order.tickets = order.tickets.filter(function (i) {
            return i.status !== 'CHANGED';
          });
          order.orderTicketsNum = tickets.length;

          if (order.tickets && order.tickets[0]) {
            order.orderContent = order.tickets[0].ticket_type.name + ' [' + order.tickets[0].play_date_begin + '] ' + order.orderTicketsNum + '张';
            order.use_valid_days = dayjs(order.tickets[0].play_date_end).diff(order.tickets[0].play_date_begin, 'days') - 0 + 1;
            order.is_refund = order.tickets[0].is_refund;
            order.ticket_type = order.tickets[0].ticket_type;
          }
        });
        _this.total = res.data.extraInfo.total;
        _this.tableData = res.data.extraInfo.list;
        console.log('this.tableData', _this.tableData);
      });
    },
    getDetail: function getDetail(order) {
      this.orderInfo = order;
      console.log('this.orderInfo', this.orderInfo);
      this.$refs.detailDialog.open();
    },
    toPay: function toPay(item) {
      this.$router.push({
        name: 'ticketPay',
        params: {
          id: item.id
        }
      });
    },
    // 取消全部订单
    cancelOrder: function cancelOrder(order) {
      console.log('order', order);
      if (!order.is_refund) return;

      if (this.allowUserPartCancel) {
        var refund_Array = order.tickets.filter(function (item) {
          return item.status === 'WAIT_USE';
        }).map(function (i) {
          return i.id;
        });

        if (!refund_Array.length) {
          this.$message.error('没有需要取消的订单');
          return false;
        }

        var params = {};
        params.id = order.id;
        params.ticketIds = refund_Array;
        this.refundOrder(params);
      } else {
        this.refundAll(order);
      }
    },
    refundOrder: function refundOrder(params) {
      var _this2 = this;

      this.$confirm('确认取消此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        cancelPart(params).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '已提交退单申请!'
          });
        });
      }).catch(function () {// on cancel
      });
    },
    // 不支持部分退
    refundAll: function refundAll(order) {
      var _this3 = this;

      var refund_Array = order.tickets.filter(function (item) {
        return item.status === 'WAIT_USE';
      });

      if (!refund_Array.length) {
        this.$message.error('没有需要取消的订单');
        return false;
      }

      this.$confirm('确认取消此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        cancelOrder(order.id).then(function (res) {
          _this3.getOrderList();

          _this3.$message({
            type: 'success',
            message: '已提交退单申请!'
          });
        });
      }).catch(function () {// on cancel
      });
    },
    refreshOrder: function refreshOrder() {
      var _this4 = this;

      if (this.rotating) return;
      this.rotating = true;
      this.getOrderList();
      setTimeout(function () {
        _this4.rotating = false;
      }, 5000);
    }
  }
};